import type { CoverpathCustomer } from '../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import type { CasApplication } from '../../../coverpath-common/classes/coverpath_subclasses/CasApplication';
import { Customer } from '../../../common/js/customer/Customer';
import { BaseQuote } from '../quote/BaseQuote';
import { SafeAdvisorQuote, SafePerson, SafePolicy, SafeTermQuote, SafeWholeQuote } from './SafePolicyInfo';

export class SafeInviteInfo {
  isJointApp: boolean;
  hasWholeQuote: boolean;
  hasTermQuote: boolean;

  firstName: string;

  // primaryCustomerFirstName: string;
  // primaryCustomerLastName: string;
  // primaryCustomerGender: string;
  // primaryCustomerDob: Date;

  // primaryPolicyInsuredFirstName: string;
  // primaryPolicyInsuredFullName: string;
  // primaryPolicyInsuredGender: string;
  // primaryPolicyInsuredDob: Date;

  policyOwnerEmailName: string;
  policyOwnerFullName: string;
  safePolicyInfo: SafePolicy;
  safeWholeQuote: SafeWholeQuote;
  safeTermQuote: SafeTermQuote;

  isAgentAssistant: boolean;
  isAgentSubmittedApp: boolean;
  advisorQuote: SafeAdvisorQuote;
  isPersonalized: boolean;
  hasPrimaryAgent: boolean;
  skipTlic: boolean;
  hasRegistered: boolean;
  primaryCustomer: SafePerson;

  constructor(unsafeQuote: BaseQuote) {
    const unsafeCustomer = unsafeQuote[0].customer as CoverpathCustomer;
    unsafeCustomer.application = unsafeQuote[0].application as CasApplication;
    this.isPersonalized = !!unsafeCustomer.application;

    this.isAgentAssistant = unsafeCustomer.application.isAgentAssistant;
    this.isAgentSubmittedApp = unsafeCustomer.application.isAgentSubmittedApp;
    this.hasRegistered = unsafeCustomer.hasRegistered;

    const primaryPolicy = unsafeQuote[0].application.primaryPolicy;
    const primaryCustomer = unsafeQuote[0].customer.primaryCustomer;
    if (!!primaryCustomer) {
      this.primaryCustomer = new SafePerson(primaryCustomer.person);
    }

    //customer.primaryCustomer is an Applicant and (often) linked to the insured
    //these are items annuities barely populate, if at all, so let's build our own one
    if (!!primaryPolicy.annuityApplication) {
      this.primaryCustomer = this.buildSafePersonFromCustomer(unsafeCustomer);
    }

    // check these conditions because depending on the invite link there
    // may not be a primaryCustomer or if there's a policy there may not
    // be an insured, and only an owner. Specifically, with annuities
    // there will only be the owner and not the insured.
    const hasPolicyAndInsured: boolean = !!primaryPolicy && !!primaryPolicy.insured;
    const hasPrimaryAndPerson: boolean = !!primaryCustomer && !!primaryCustomer.person;
    const hasPrimaryAndOwner: boolean = !!primaryPolicy && !!primaryPolicy.owner;

    let safePolicyInfo;
    if (!!unsafeCustomer.application) {
      safePolicyInfo = new SafePolicy(unsafeCustomer.application);
    }

    this.firstName = unsafeCustomer.firstName;

    this.safePolicyInfo = safePolicyInfo;

    this.hasPrimaryAgent = !!primaryPolicy.primaryPolicyAgent;
    this.isJointApp = unsafeCustomer.application.isJointAppWithPendingAmendment();

    this.hasWholeQuote = !!unsafeCustomer.wholeLifeQuote;
    if (this.hasWholeQuote) {
      this.safeWholeQuote = new SafeWholeQuote(unsafeCustomer.wholeLifeQuote);
    }

    this.hasTermQuote = !!unsafeCustomer.termQuote;
    if (this.hasTermQuote) {
      this.safeTermQuote = new SafeTermQuote(unsafeCustomer.termQuote);
    }

    this.advisorQuote = new SafeAdvisorQuote(unsafeCustomer.advisorQuote);
    this.skipTlic = unsafeCustomer.application.skipTLIC;
  }

  private buildSafePersonFromCustomer(customer: Customer): SafePerson {
    return {
      firstName: customer.firstName,
      lastName: customer.lastName,
      fullName: customer.firstName + ' ' + customer.lastName,
      gender: '',
      dob: undefined,
      email: customer.email,
      emailName: customer.firstName,
    } as SafePerson;
  }
}
